import { CaretDown } from "@assets/icons";
import { LINKS, LinkType } from "@components/Link/Link";
import classNames from "classnames";
import { Link } from "gatsby";
import React, { HTMLProps } from "react";
import { TypographyV2 } from "..";
import * as styles from "./NavigationButton.module.scss";

type Props = {
	open: boolean;
	title: string;
	to?: LinkType;
} & HTMLProps<HTMLDivElement>;

const NavigationButton = ({ open, title, className, to, ...props }: Props) => {
	const component = (
		<div
			className={classNames(styles.navigationButton, {
				[styles.open]: open,
				classNames,
			})}
			{...props}
		>
			<TypographyV2
				variant="BODY_TEXT_MEDIUM_V1"
				weight="MEDIUM"
				color="menu-item"
				className={classNames(styles.title,{
					[styles.open]: open,
				})}
			>
				{title}
			</TypographyV2>
			{!to && (
				<CaretDown
					className={styles.caretIcon}
					style={{
						transform: open ? "rotate(180deg)" : "",
						transition: "transform 0.2s ease",
					}}
				/>
			)}
		</div>
	);
	if (to) {
		return <Link to={LINKS[to].to}>{component}</Link>;
	} else {
		return component;
	}
};

export default NavigationButton;
